<div class="side-menu px-3">
  <ng-container *appDynamicLoader="appMeta"></ng-container>
</div>
